
import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';


export default {
    getGroups,
    GetEmployeeTypesData,
    getEstatesByGroupID,
    GetCollectionCategoryByOperationEntityID,
    GetPaymentRates,
    updateRates

};


async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function GetEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}



async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]

    }
    return array;
}

async function GetCollectionCategoryByOperationEntityID(id) {
    var collectionCategoryArray = [];
    const response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionCategoryArray[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"]
        }
    }
    return collectionCategoryArray;
}

async function GetPaymentRates(collectionCategoryID) {
    const res = await CommonGet('/api/PaymentRates/GetPaymentRates', 'collectionCategoryID=' + collectionCategoryID);
    return res.data;
}

async function updateRates(data) {
    const updateModel = {
        HaverstingJobTypeID: data.haverstingJobTypeID,
        MinRate: data.minRate,
        MaxRate: data.maxRate,
        OldMinRate: data.oldMinRate,
        OldMaxRate: data.oldMaxRate,
        IsActive: data.isActive,
        PaymentEnabled: data.paymentEnabled,
        ModifiedBy: parseInt(tokenDecoder.getUserIDFromToken())

    }
    var result = await CommonPost('/api/PaymentRates/UpdateRates', null, updateModel);
    return result;

}

